import './container.css';

const Container = ({children, ...props}) => (
  <div class="container">
    {children}
  </div>
);

export default Container;